module.exports = __webpack_public_path__ + "static/dashboard_intro4@2x-e842f354c88ccd3bc0e24d98b45bdd7d.png";